import { format } from 'owa-strings';
import { getOwaMiniStrings, OwaMiniStrings } from 'owa-strings/owa-mini-strings';

export default function getChevronIconAriaLabel(isExpanded: boolean, folderName: string) {
    const strings: OwaMiniStrings = getOwaMiniStrings();
    return isExpanded
        ? format(strings.folderExpandedAriaLabel, folderName)
        : format(strings.folderCollapsedAriaLabel, folderName);
}
